export default __webpack_public_path__ + "static/home_developer-29db61b7703dd32868c043ed6fb86341.webp";